@if (!shouldRenderVideo()) {
<df-image-wrapper [class]="photoswipeClass()"
                  [class._hasImageZoom]="hasImageZoom()"
                  [class._hasVideoZoom]="hasVideoZoom()">
    <img [class.w-12]="!width()"
         [ratio]="ratio()"
         [width]="width()"
         [dfImage]="source().image || ''"
         [alt]="alt()"
         [loaderParams]="options()"
         [photoswipe]="photoswipeImage() || ''"
         [photoswipeUid]="photoswipeUid() || ''"
         [photoswipeHtml]="videoIframeHtml() || ''"
         [photoswipeThumbnail]="photoswipeImage() || ''"
         [photoswipeOptions]="photoswipeOption() || {}">
</df-image-wrapper>
}@else{
@if(isVimeo()){
<vimeo-player class="bg-col-w"
              [video-url]="source().video || ''"
              [background]="true"
              [autoplay-in-viewport]="true"
              [loop]="true">
</vimeo-player>
}@else {
<youtube-player class="bg-col-w"
                [video-id]="source().video || ''"
                [background]="true"
                [autoplay-in-viewport]="true"
                [loop]="true">
</youtube-player>
}
}